export default {
  api: {},
  details: [],
  fields: [],
  name: null,
  messages: [],
  offer: {},
  steps: [],
  summary: []
};
